import React, { useRef, useEffect } from "react";
import styled from "styled-components";
import * as echarts from 'echarts';
import moment from 'moment'

const ShareChart = ({ data, nickname = '', animation = true, mode }) => {
  const chartRef = useRef();
  useEffect(() => {
    if (!data.details || data.details.length === 0) {
      return;
    }
    const $0 = [];
    const $1 = [];
    const date = [];

    if (mode === 'fast') {
      data.shDetails.forEach((item, index) => {
        $0.push(item.incomeRatio);
        if (data.details[index] === undefined) {
          const last = data.details[data.details.length - 1];
          $1.push(last.incomeRatio)
        } else {
          $1.push(data.details[index].incomeRatio)
        }
        
        date.push(item.date);
      })
    } else {
      data.shDetails.forEach((item, index) => {
        $0.push(item.incomeRatio);
        if (data.details[index] === undefined) {
          const last = data.details[data.details.length - 1];
          $1.push(last.incomeRatio)
        } else {
          $1.push(data.details[index].incomeRatio)
        }
        
        date.push(item.date);
      })
    }

    // data.details.forEach((item, index) => {
    //   $0.push(item.incomeRatio)
    //   date.push(item.date);
    //   $1.push(data.shDetails[index] ? data.shDetails[index].incomeRatio : '-');
    // })
    const startDate = moment(`${date[0]}`).format('YYYY-MM');
    const endDate = moment(`${date[date.length - 1]}`).format('YYYY-MM');
    const options = {
      animation,
      color: ['#FFAB42', '#AF4E1D'],
      title: [{
        subtext: startDate,
        left: '0',
        bottom: '0',
        subtextStyle: {
          fontSize: 10,
          color: '#000'
        },
        padding: [5, 10, 5, 10]
      }, {
        subtext: endDate,
        right: '0',
        bottom: '0',
        subtextStyle: {
          fontSize: 10,
          color: '#000'
        },
        padding: [5, 10, 5, 10]
      }],
      legend: {
        left: '12',
        textStyle: {
          color: '#B13B2C',
          fontSize: 10
        },
        itemGap: 10,
        itemWidth: 8,
        itemHeight: 8,
        icon: 'circle',
        data: [
          { name: nickname },
          { name: '上证指数' },
        ]
      },
      grid: {
        containLabel: true,
        bottom: '15%',
        right: 12,
        top: '15%',
        left: 12
      },
      xAxis: [
        {
          type: 'category',
          axisLine: {
            lineStyle: {
              color: '#E4E4E4',
              width: 2,
              type: 'dashed'
            }
          },
          splitArea: false,
          splitLine: false,
          axisTick: false,
          data: date,
          axisLabel: false,
        }
      ],
      yAxis: [
        {
          position: 'right',
          show: true,
          type: 'value',
          yAxisIndex: 0,
          axisLine: false,
          splitNumber: 5,
          axisTick: false,
          splitArea: false,
          splitLine: {
            lineStyle: {
              color: '#E4E4E4',
              width: 1.5,
              type: 'dashed'
            }
          },
          axisLabel: {
            color: '#171717',
            fontSize: 10,
            formatter: (value) => (value * 100) + '%'
          }
        },
      ],
      series: [
        {
          name: nickname,
          yAxisIndex: 0,
          type: 'line',
          lineStyle: {
            type: 'solid',
          },
          barWidth: '60%',
          data: $1,
          symbol: 'none'
        },
        {
          name: '上证指数',
          yAxisIndex: 0,
          type: 'line',
          lineStyle: {
            type: 'solid',
          },
          barWidth: '60%',
          data: $0,
          symbol: 'none'
        },
      ]
    }
    const chart = echarts.init(chartRef.current)
    chart.setOption(options, true);
  }, [data, mode]);

  return (
    <Container>
      <div ref={chartRef} className="chart-container"></div>
    </Container>
  )
}

const Container = styled.div`
  .chart-container {
    height: 190px;
  }
`;

export default React.memo(ShareChart);


// WEBPACK FOOTER //
// ./src/views/activity_31/components/chart.js